<script>
// import axios from "axios";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
// import { mapState, mapGetters } from "vuex";

import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import { Carousel, Slide } from '@jambonn/vue-carousel';
/**
 * Login component
 */

export default {
  page: {
    title: "Inicio de sesión",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // Layout,
    Carousel,
    Slide
  },
  data() {
    return {
      images: [
      require('@/assets/cerdos/2.jpeg')
      ],
      apiUrl: process.env.VUE_APP_URL,
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),

    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    async tryToLogIn() {
      const { email, password } = this;
      await this.login({ email, password });
      // location.reload();
    },
    getBackgroundStyle(image) {
      console.log(image);
      return {
          backgroundImage: `url(${image})`
      };
    },  
    preloadImages() {
      this.images.forEach(image => {
        const img = new Image();
        img.src = image;
      });
    },
    onValidate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.tryToLogIn();
      }
    },
  },
  mounted() {
    this.preloadImages();
    const usuario = this.$store.state.authfack.user;
    // console.log(usuario);
    if (usuario === "" || usuario === null || usuario === "null" || usuario.token === undefined) {
      // console.log('entro')
      this.logout();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {
          "x-token":  usuario.token,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
        });
    }
  },
};
</script>

<template>
  <div class="login-container">
    <carousel
      :autoplay="false"
      :autoplayTimeout="5000"
      :loop="false"
      :perPage="1"
      :navigationEnabled="true"
      :paginationEnabled="false"
      class="slider"
    >
      <slide v-for="(image, index) in images" :key="index">
        <img v-if="image" :src="image" class="slide-image" alt="Imagen de fondo" />
      </slide>
    </carousel>
    <div class="login-container">
    <div class="login-card login-card-left">
      <div class="card">
        <div class="logo">
          <img src="@/assets/cerdos/granja.png" alt="Logo" class="logo-img logo-img-large" />
        </div>
        <b-alert
          v-model="isAuthError"
          variant="danger"
          class="mt-3"
          dismissible
        >{{ authError }}</b-alert>
        <b-form @submit.prevent="onValidate">
          <b-form-group label="Usuario" label-for="input-1" label-size="lg">
            <b-form-input
              id="input-1"
              v-model="email"
              type="text"
              placeholder="Ingrese el usuario"
              :class="{ 'is-invalid': submitted && $v.email.$error }"
              size="lg"
            ></b-form-input>
            <div
              v-if="submitted && $v.email.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.email.required" style="font-size: 1.4rem;">El usuario es necesario.</span>
            </div>
          </b-form-group>

          <b-form-group label="Contraseña" label-for="input-2" label-size="lg">
            <b-form-input
              id="input-2"
              v-model="password"
              type="password"
              placeholder="Ingrese la contraseña"
              :class="{ 'is-invalid': submitted && $v.password.$error }"
              size="lg"
            ></b-form-input>
            <div
              v-if="submitted && !$v.password.required"
              class="invalid-feedback"
            >
              <span style="font-size: 1.4rem;">La contraseña es necesaria.</span>
            </div>
          </b-form-group>

          <div class="mt-4">
            <b-button type="submit" variant="primary" block size="lg">Iniciar Sesión</b-button>
          </div>
        </b-form>
        <p class="footer-text">
          © {{ new Date().getFullYear() }} Granja El Bosque. Inovación Continua.
          <i class="mdi mdi-heart text-danger"></i> Todos los derechos reservados.
        </p>
      </div>
    </div>
  </div>
  </div>
</template>
<style scoped>
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  overflow: hidden;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.login-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 600px;
  margin-left: 5%;
}

.card {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 25px;
  padding: 50px;
  box-shadow: 0 15px 60px rgba(0, 0, 0, 0.2);
}

.logo {
  text-align: center;
  margin-bottom: 30px;
}

.logo-img {
  max-width: 250px;
  width: 100%;
  height: auto;
}

.footer-text {
  font-size: 1rem;
  color: #666;
  margin-top: 20px;
  text-align: center;
}

.form-group label {
  font-weight: 700;
  color: #333;
  font-size: 1.8rem;
}

.form-control {
  border-radius: 12px;
  border: 1px solid #ced4da;
  padding: 18px 25px;
  font-size: 1.6rem;
}

.btn-primary {
  background-color: #007bff;
  border: none;
  border-radius: 12px;
  padding: 18px;
  font-weight: 700;
  font-size: 1.6rem;
  transition: background-color 0.3s ease;
}

.btn-primary:hover {
  background-color: #0056b3;
}

@media (max-width: 768px) {
  .login-container {
    padding: 10px;
  }
  .card {
    padding: 40px;
  }
  .form-group label {
    font-size: 1.6rem;
  }
  .form-control {
    padding: 15px 20px;
    font-size: 1.4rem;
  }
  .btn-primary {
    padding: 15px;
    font-size: 1.4rem;
  }
  .footer-text {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .login-card {
    max-width: 90%;
  }
  .card {
    padding: 30px;
  }
  .form-group label {
    font-size: 1.5rem;
  }
  .form-control {
    padding: 12px;
    font-size: 1.4rem;
  }
  .btn-primary {
    padding: 12px;
    font-size: 1.4rem;
  }
  .footer-text {
    font-size: 0.9rem;
  }
}
</style>
